import { useState, useEffect, useRef } from 'react';
import { Select, Spin } from 'antd';

import CustomerOrdersServices from '../../services/customerOrdersServices';
import { useTranslation } from 'react-i18next';
import { useUserAuth } from '../../context/UserContext';

const DynamicSelect = ({ type, value, onChange, onSelectChange, location }) => {
    const { t } = useTranslation();
    const { user } = useUserAuth();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetched, setFetched] = useState(false);
    const cacheRef = useRef({});

    useEffect(() => {
        if (location === 'update') {
            fetchOptions();
        }
    }, []);

    const fetchOptions = async () => {
        if (fetched || cacheRef.current[type]) {
            setOptions(cacheRef.current[type] || []);
            return;
        }

        setLoading(true);
        try {
            const respData = await CustomerOrdersServices.getFilterData(type, user.id);
            const items = respData?.responseObject?.value?.filtersByTypes ?? [];
            const optionsRes = items.map(({ id, name }) => ({
                value: id,
                label: name
            }));
            cacheRef.current[type] = optionsRes; // cache it
            setOptions(optionsRes);
            setFetched(true);
        } catch (err) {
            console.error(`Failed to fetch options for type: ${type}`, err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Select
            size='small'
            style={{ width: "100%" }}
            showSearch
            allowClear
            value={value}
            onChange={(val, option) => {
                onChange?.(val); // <-- required for Form.Item to register change
                onSelectChange?.(type, option);
            }}
            placeholder={t('general.select')}
            optionFilterProp="label"
            onDropdownVisibleChange={(open) => {
                if (open) fetchOptions();
            }}
            notFoundContent={loading ? <Spin size="small" /> : t('messages.noData')}
            loading={loading}
            options={options}
            // disabled={location === "update" ? (loading ?? true) : false}
            disabled={location === "update" ? (true) : false}

        >
        </Select>
    );
};

export default DynamicSelect;
